import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import mixin from '@/common/mixin'
import verifyClick from '@/directives/verifyClick'

Vue.use(ElementUI)
Vue.mixin(mixin)
Vue.directive('verify-click', verifyClick)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
